import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PROTECTED_EMAILS, decodeEmail } from "../utils/emailProtection";
import { blogPosts } from "../Blog/blogPosts";
import "../css/header-blog-flash.css";
function Header() {
  const { pathname } = useLocation();
  const isBlogPostRoute = pathname.startsWith("/blog/");

  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const [menuActive, setMenuActive] = useState(false);
  const [menuIconActive, setMenuIconActive] = useState(false);
  const [dropdownActive, setdropdownActive] = useState(false);
  const [vpsDropdownActive, setvpsDropdownActive] = useState(false);

  const latestBlogPost =
    blogPosts && blogPosts.length
      ? blogPosts.reduce((latest, post) => {
          const latestDate = new Date(latest?.date || 0);
          const currentDate = new Date(post?.date || 0);
          return currentDate > latestDate ? post : latest;
        }, blogPosts[0])
      : null;

  const menuToggle = () => {
    if (menuActive === false) {
      setTimeout(() => {
        document.querySelector(".nav-ul").classList.add("slide-open");
      }, 200);

      setMenuIconActive(true);

      setMenuActive(true);
    } else if (menuActive === true) {
      document.querySelector(".nav-ul").classList.remove("slide-open");

      setTimeout(() => {
        setMenuIconActive(false);
        setMenuActive(false);
      }, 500);
    }
  };
  const dropdownHandler = (e) => {
    console.log(e.target);
    setdropdownActive(!dropdownActive);
  };

  const vpsDropdownHandler = (e) => {
    console.log(e.target);
    setvpsDropdownActive(!vpsDropdownActive);
  };

  return (
    <>
      {latestBlogPost ? (
        <div
          className={`blog-flash-strip ${isBlogPostRoute ? "blog-flash-strip--post" : ""}`}
          aria-label="Latest blog update"
        >
          <div className="container blog-flash-inner">
            <span className="blog-flash-badge">NEW BLOG</span>
            <Link
              to={`/blog/${latestBlogPost.slug}`}
              className="blog-flash-link"
              onClick={gotoTop}
            >
              {latestBlogPost.title}
            </Link>
          </div>
        </div>
      ) : null}

      {/* ====== Top Bar =======  */}
      <section
        id="topbar"
        className={`d-flex align-items-center ${isBlogPostRoute ? "topbar-blog-post" : ""}`}
      >
        <div className="container d-flex justify-content-center justify-content-md-between">
          <div className="contact-info d-none d-md-flex align-items-center">
            <i className="bi bi-phone d-flex align-items-center" style={{ marginRight: "15px" }}>
              <Link 
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = 'tel:+910116931028';
                }}
              >
                +91 011 6931 0286
              </Link>
            </i>
            <i className="bi bi-envelope d-flex align-items-center">
              <Link 
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${decodeEmail(PROTECTED_EMAILS.SUPPORT)}`;
                }}
              >
                {decodeEmail(PROTECTED_EMAILS.SUPPORT)}
              </Link>
            </i>
          </div>
          <div className="social-links d-flex align-items-center">
            <Link
              to="https://my.clubhosty.com/clientarea.php"
              className="mainbtn"
            >
              {" "}
              Client Login
            </Link>
          </div>
        </div>
      </section>
      {/* ======= End Top Bar ======= */}

      {/* ======= Header =======  */}
      <header
        id="header"
        className={`d-flex align-items-center ${isBlogPostRoute ? "header-blog-post" : ""}`}
      >
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/" className="logo" onClick={gotoTop}>
            <img src="/assets/img/logo.webp" alt="clubhosty" />
          </Link>

          <nav
            id="navbar"
            className={menuActive ? "navbar navbar-mobile " : "navbar"}
          >
            <ul className="nav-ul">
              <div className="mobile-nav-header">
                <a className="logo" href="/">
                  <img src="/assets/img/logo.webp" alt="clubhosty" />
                </a>
                <span className="x-icon">
                  <i
                    onClick={menuToggle}
                    className="bi bi-x mobile-nav-toggle "
                  ></i>
                </span>
              </div>
              <li>
                <Link
                  to="/"
                  className="nav-link"
                  onClick={() => {
                    gotoTop();
                    setMenuActive(false);
                    setMenuIconActive(false);
                  }}
                >
                  <span>HOME</span>
                </Link>
              </li>
              <li onClick={dropdownHandler} className="dropdown">
                <Link to="#">
                  <span>HOSTING</span> <i className="bi bi-chevron-down"></i>
                </Link>
                <ul className={dropdownActive ? "dropdown-active" : ""}>
                  <li>
                    <Link
                      to="/sharedHosting"
                      onClick={() => {
                        setMenuActive(false);
                        setMenuIconActive(false);
                        gotoTop();
                      }}
                    >
                      Shared Hosting
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/affordable-cpanel-hosting"
                      onClick={() => {
                        setMenuActive(false);
                        setMenuIconActive(false);
                        gotoTop();
                      }}
                    >
                      Cpanel Hosting
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to="/cloud-based-hosting-services"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>CLOUD</span>
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/affordable-reseller-web-hosting"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>RESELLER</span>
                </Link>
              </li>
              <li onClick={vpsDropdownHandler} className="dropdown">
                <Link to="#">
                  <span>VPS SERVER</span> <i className="bi bi-chevron-down"></i>
                </Link>
                <ul className={vpsDropdownActive ? "dropdown-active" : ""}>
                  <li>
                    <Link
                      to="/affordable-vps-hosting"
                      onClick={() => {
                        setMenuActive(false);
                        setMenuIconActive(false);
                        gotoTop();
                      }}
                    >
                      VPS Hosting
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/storage-vps-hosting"
                      onClick={() => {
                        setMenuActive(false);
                        setMenuIconActive(false);
                        gotoTop();
                      }}
                    >
                      Storage VPS
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to="/colocation-india"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>COLOCATION</span>
                </Link>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to="/domain"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>DOMAIN</span>
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/blog"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>BLOG</span>
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/contact"
                  onClick={() => {
                    setMenuActive(false);
                    setMenuIconActive(false);
                    gotoTop();
                  }}
                >
                  <span>CONTACT US</span>
                </Link>
              </li>
              <div className="mobile-contact">
                <Link to="https://my.clubhosty.com/clientarea.php">
                  <i class="bi bi-box-arrow-in-right"></i>
                  <span>Login</span>
                </Link>
                <Link to="tel:+911169310286">
                  <i class="bi bi-telephone"></i>
                  <span>Call</span>
                </Link>
                <Link 
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${decodeEmail(PROTECTED_EMAILS.SUPPORT)}`;
                  }}
                >
                  <i class="bi bi-envelope"></i>
                  <span>Email</span>
                </Link>
              </div>
            </ul>
            {!menuIconActive ? (
              <i
                onClick={menuToggle}
                className="bi bi-list mobile-nav-toggle"
              ></i>
            ) : null}
          </nav>
          {/* .navbar */}
        </div>
      </header>
      {/* End Header  */}
    </>
  );
}

export default Header;
